module.exports = __webpack_public_path__ + "static/media/IMG_7952.0c624bc6.JPG";